import React from "react";
import { Box, Grid, Paper, Typography, useTheme } from "convertupleads-theme";

const fontConstant = ["Inter", "sans-serif"].join(",");
const typographyProperties = [
  {
    name: "h1",
    fontFamily: fontConstant,
    fontWeight: 300,
    fontSize: "96px",
    lineHeight: "112px",
    letterSpacing: "-1.5px",
  },
  {
    name: "h2",
    fontFamily: fontConstant,
    fontWeight: 300,
    fontSize: "60px",
    lineHeight: "120%",
    letterSpacing: "-0.5px",
  },
  {
    name: "h3",
    fontFamily: fontConstant,
    fontWeight: 400,
    fontSize: "48px",
    lineHeight: "116.7%",
    letterSpacing: "0",
  },
  {
    name: "h4",
    fontFamily: fontConstant,
    fontWeight: 400,
    fontSize: "34px",
    lineHeight: "123.5%",
    letterSpacing: "-1.25px",
  },
  {
    name: "h5",
    fontFamily: fontConstant,
    fontWeight: 600,
    fontSize: "24px",
    lineHeight: "30px",
    letterSpacing: "-0.85px",
  },
  {
    name: "h6",
    fontFamily: fontConstant,
    fontWeight: 600,
    fontSize: "20px",
    lineHeight: "28px",
    letterSpacing: "-0.5px",
  },
  {
    name: "subtitle1",
    fontFamily: fontConstant,
    fontWeight: 500,
    fontSize: "18px",
    lineHeight: "26px",
    letterSpacing: "-0.35px",
  },
  {
    name: "subtitle2",
    fontFamily: fontConstant,
    fontWeight: 500,
    fontSize: "15px",
    lineHeight: "18px",
    letterSpacing: "-0.35px",
  },
  {
    name: "body1",
    fontFamily: fontConstant,
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "150%",
    letterSpacing: "-0.25px",
  },
  {
    name: "body2",
    fontFamily: fontConstant,
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "-0.15px",
  },
  {
    name: "button",
    fontFamily: fontConstant,
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "24px",
    letterSpacing: "-0.2px",
    textTransform: "capitalize",
  },
  {
    name: "caption",
    fontFamily: fontConstant,
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "18px",
    letterSpacing: "-0.15px",
  },
  {
    name: "overline",
    fontFamily: fontConstant,
    fontWeight: 500,
    fontSize: "11px",
    lineHeight: "12px",
    letterSpacing: "0.75px",
    textTransform: "uppercase",
  },
];

const TypographyProperties = () => {
  const theme = useTheme();

  return (
    <Box p={3}>
      <Typography variant={"h6"} color={"text.primary"} mb={3}>
        Typography Variant Properties
      </Typography>
      <Box sx={{ width: "90%", margin: "0 auto" }}>
        <Grid container spacing={2}>
          {typographyProperties?.map((typo) => {
            return (
              <Grid item xs={12} md={6} lg={4}>
                <Paper
                  variant={"outlined"}
                  sx={{
                    borderRadius: "8px",
                    borderColor: theme.palette.other.outlinedBorder,
                    p: 2,
                    height: "100%",
                  }}
                >
                  <table>
                    <tbody>
                      <tr>
                        <td colSpan={3}>
                          <Typography variant={"subtitle1"}>
                            {typo.name}
                          </Typography>
                        </td>
                      </tr>
                      <tr>
                        <td>font-family</td>
                        <td>:</td>
                        <td>{typo.fontFamily}</td>
                      </tr>
                      <tr>
                        <td>font-weight</td>
                        <td>:</td>
                        <td>{typo.fontWeight}</td>
                      </tr>
                      <tr>
                        <td>font-size</td>
                        <td>:</td>
                        <td>{typo.fontSize}</td>
                      </tr>
                      <tr>
                        <td>line-height</td>
                        <td>:</td>
                        <td>{typo.lineHeight}</td>
                      </tr>
                      <tr>
                        <td>letter-spacing</td>
                        <td>:</td>
                        <td>{typo.letterSpacing}</td>
                      </tr>
                      {typo.textTransform && (
                        <tr>
                          <td>text-transform</td>
                          <td>:</td>
                          <td>{typo.textTransform}</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </Paper>
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </Box>
  );
};

export default TypographyProperties;
